export const colors = {
  expense: 'red',
  income: 'green',
  investmentNeg: '#3f51b5', // Azul Índigo para aportación / inversiones negativas
  investmentPos: '#ba68c8', // Violeta / lila claro para retorno / inversiones positivas
};

/**
 * Retorna el color correspondiente para un importe según si es inversión o no.
 * @param {number} importe 
 * @param {boolean} isInvestment 
 * @returns {string} color
 */
export const getColorForAmount = (importe, isInvestment) => {
  if (isInvestment) {
    return importe < 0 ? colors.investmentNeg : colors.investmentPos;
  }
  return importe < 0 ? colors.expense : colors.income;
};
